import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

const requestConfig = () => ({
  headers: { Authorization: `Bearer ${getJwtToken()}` },
});

export const retryEngagementFollowUp = async (id, version) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/engagements/${encodeURIComponent(id)}/follow-up/retry`,
    { version },
    requestConfig()
  );

export const getEngagementSummary = async (period) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/engagements/summary`,
    { ...requestConfig(), params: period }
  );

export const getEngagements = async (stage, page, size, period) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/engagements`,
    { ...requestConfig(), params: { stage, page, size, ...period } }
  );
